// frontend/src/pages/CaseReportPage.js
import { useTranslation } from "react-i18next";

export default function CaseReportPage() {
  const { t } = useTranslation();

  const faqs = [
    {
      question: "faqs.caseReport.q1.question",
      answer: "faqs.caseReport.q1.answer",
    },
    {
      question: "faqs.caseReport.q2.question",
      answer: "faqs.caseReport.q2.answer",
    },
    {
      question: "faqs.caseReport.q3.question",
      answer: "faqs.caseReport.q3.answer",
    },
    {
      question: "faqs.caseReport.q4.question",
      answer: "faqs.caseReport.q4.answer",
    },
    {
      question: "faqs.caseReport.q5.question",
      answer: "faqs.caseReport.q5.answer",
    },
  ];

  return (
    <div className="container mx-auto px-6 py-12">
      <h1 className="text-4xl font-bold text-center mb-8">
        {t("faqs.caseReport.title")}
      </h1>
      <div className="space-y-6">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="border border-gray-300 dark:border-gray-700 rounded-lg p-4"
          >
            <h3 className="font-semibold text-xl">{t(faq.question)}</h3>
            <p className="mt-2 text-gray-600 dark:text-gray-400">
              {t(faq.answer)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
